<template>
    <b-card body-class="p-3 email-schedule">
        <div class="d-flex title-bar-block mb-4">
            <div class="icon-block me-4">
                <button id="close-label-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ $translate('email_schedule') }}</span>
            </div>
        </div>

        <b-card-body class="p-0">
            <b-overlay :show="loading" rounded="sm">
                <div>

                    <b-card no-body>
                        <b-tabs card>
                            <b-tab title="Schedule" active>
                                <b-card-text>
                                    <b-form class="form-sample" @submit.stop.prevent="onSubmit">
                                        <b-row class="filter-form p-0">
                                            <b-col v-for="(d_item, i) in formFields" class="mt-2" cols="12"
                                                :md="d_item.cols" :key="`type ${i} group`" :id="d_item.field">
                                                <b-form-group>
                                                    <label :for="'input-' + d_item.field" class="mb-3">
                                                        <strong>{{ getLabel(d_item.label) }}<span class="red"
                                                                v-if="d_item.required">*</span></strong>
                                                    </label>
                                                    <QueryFilter v-if="d_item.type === 'query'"
                                                        :category="model.category" v-model="model[d_item.field]">
                                                    </QueryFilter>

                                                    <b-form-select v-else-if="d_item.type === 'select'"
                                                        :id="'input-' + d_item.field" v-model="model[d_item.field]"
                                                        :required="d_item.required"
                                                        v-custom-validation="d_item.required ? $selectRequired() : ''"
                                                        :options="getOptions(d_item.field)"
                                                        :disabled="is_one_off_linked(d_item.field)">
                                                        <template #first>
                                                            <b-form-select-option :value="null"
                                                                :disabled="d_item.required">
                                                                {{ `${$translate("select")} ${getLabel(d_item.label)}`
                                                                }}
                                                            </b-form-select-option>
                                                        </template>
                                                    </b-form-select>


                                                    <b-form-textarea v-else-if="d_item.type === 'textarea'"
                                                        :id="'input-' + d_item.field" v-model="model[d_item.field]"
                                                        :required="d_item.required"
                                                        v-custom-validation="d_item.required ? $textRequired() : ''"
                                                        :placeholder="`${$translate('enter')} ${getLabel(d_item.label)}`"
                                                        :rows="3" :max-rows="6">
                                                    </b-form-textarea>

                                                    <b-form-input v-else-if="d_item.field == 'time_of_day'"
                                                        :type="d_item.type"
                                                        :disabled="is_one_off_linked(d_item.field) || (d_item?.disabled || false)"
                                                        :id="'input-' + d_item.field" v-model="timeOfDayDisplay"
                                                        :required="d_item.required" :min="d_item?.min"
                                                        v-custom-validation="d_item.required ? $textRequired() : ''"
                                                        :placeholder="`${$translate('enter')} ${getLabel(d_item.label)}`"
                                                        trim>
                                                    </b-form-input>

                                                    <b-form-input v-else
                                                        :disabled="is_one_off_linked(d_item.field) || (d_item?.disabled || false)"
                                                        :type="d_item.type" :id="'input-' + d_item.field"
                                                        v-model="model[d_item.field]" :required="d_item.required"
                                                        :min="d_item?.min"
                                                        v-custom-validation="d_item.required ? $textRequired() : ''"
                                                        :placeholder="`${$translate('enter')} ${getLabel(d_item.label)}`"
                                                        trim>
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>


                                        <b-row>


                                            <b-col cols="12" class="mt-4 mb-2 text-center">
                                                <b-button id="create-schedule-btn" class="btn btn-info btn-fw me-2"
                                                    type="submit" v-if="hasPermissionCreate && !model.id"
                                                    variant="primary" :disabled="loading ? true : false">{{ createLabel
                                                    }}</b-button>
                                                <b-button id="update-schedule-btn" class="btn btn-info btn-fw me-2"
                                                    type="submit" v-if="hasPermissionUpdate && model.id"
                                                    variant="primary" :disabled="loading ? true : false">{{ updateLabel
                                                    }}</b-button>

                                                <b-button id="delete-schedule-btn"
                                                    v-if="model.id && hasPermissionDelete"
                                                    @click="deleteEmailSchedule()" class="me-1" variant="delete-button">
                                                    {{ $translate('delete') }}
                                                </b-button>

                                                <b-button id="test-email-btn" v-if="model.id" @click="triggerEmails()"
                                                    class="me-1">
                                                    {{ $translate('test_email') }}
                                                </b-button>


                                                <b-button variant="info" id="cancel-btn" class="btn-fw"
                                                    :disabled="loading ? true : false" @click="cancel()">{{
                                                        $cancelLabel() }}</b-button>
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </b-card-text>
                            </b-tab>
                            <b-tab title="Template">
                                <b-card-text>
                                    <b-row>
                                        <b-col cols="8">
                                            <TipTap v-model="model.template_data" />
                                            <b-button @click="onSubmit">Update</b-button>
                                        </b-col>
                                        <b-col>
                                            <b-row>
                                                <b-col cols="12" v-for="item in mailMergeData"
                                                    :key="item + 'mailmerge'">
                                                    {{ item }}
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-card-text>
                            </b-tab>

                        </b-tabs>
                    </b-card>
                </div>
            </b-overlay>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import QueryFilter from './QueryFilter.vue'

import TipTap from "@/components/TipTap/Index.vue"

const tomorrow_date = new Date().toISOString().split("T")[0];

const dataItems = [
    //mandatory  but must be automated
    {
        field: "name",
        label: "name",
        type: "text",
        required: true,
        cols: 6
    },
    { field: "category", label: "category", type: "select", required: true, cols: 6 },
    {
        field: "description",
        label: "description",
        type: "textarea",
        required: false,
        cols: 12
    },
    {
        field: "email_subject",
        label: "subject",
        type: "text",
        required: true,
        cols: 12
    },
    {
        field: "email_from_name",
        label: "from_name",
        type: "text",
        required: true,
        cols: 12
    },


    { field: "query_fields", label: "Query", type: "query", required: true, cols: 12 },


    { field: "frequency", label: "frequency", type: "select", required: true, cols: 4 },
    { field: "last_date", label: "previous_date", type: "date", cols: 4 },
    {
        field: "next_date",
        label: "next_date",
        type: "date",
        required: true,
        min: tomorrow_date,
        cols: 4
    },
    {
        field: "day_of_week",
        label: "day_of_week",
        type: "select",
        required: false,
        cols: 4
    },
    {
        field: "time_of_day",
        label: "time_of_day",
        type: "time",
        required: false,
        cols: 4
    },
    {
        field: "termination_date",
        label: "termination_date",
        type: "date",
        required: false,
        cols: 4
    },


];


const default_model = {
    id: 0,
    name: null,
    email_subject: null,
    email_from_name: null,
    description: null,
    last_date: null,
    next_date: null,
    day_of_week: null,
    time_of_day: null,
    category: null,
    query_fields: null,
    termination_date: null,
    frequency: null,
    email_template_id: 1
};


export default {
    name: 'EmailScheduler-viewItem',
    components: { TipTap, QueryFilter },
    mixins: [popupMixins, permissionsMixins, errorHandlingMixins],
    data() {
        return {
            model: {
                id: 0,
                name: null,
                email_subject: null,
                email_from_name: null,
                description: null,
                last_date: null,
                next_date: null,
                day_of_week: null,
                time_of_day: null,
                category: null,
                query_fields: null,
                termination_date: null,
                frequency: null,
                email_template_id: 1
            },
            updating: false,
            submitting: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {

        mailMergeData() {
            return [
                "first_name",
                "last_name",
                "email",
                "web_url",
                "subject",
                "customer.name",
                "customer.email",
                "customer.code",
                "customer.phone",
                "customer.work_number",
                "company.name",
                "company.email",
                "company.address1",
                "company.address2",
                "company.city",
                "company.country_code",
                "company.state",
                "company.zip_code",
                "company.postal",
                "company.county",
                "company.logo_url",
                "company.tagline",
                "company.phone",
            ]



        },

        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        scheduleItem() {
            const { item } = this;
            const _item = this.$store.state.emailSchedules.item;
            return { ...item, ..._item };
        },
        loading() {
            return this.$store.state.emailSchedules.loading;
        },

        formFields() {
            return dataItems;
        },
        frequencies() {
            return [
                { value: 0, text: 'One-Off' },
                { value: 1, text: 'Daily' },
                { value: 7, text: 'Weekly' },
                { value: 30, text: 'Monthly' },
                { value: 90, text: 'Quarterly' }
            ]
        },

        weekDays() {
            return [
                { value: 0, text: 'Sunday' },
                { value: 1, text: 'Monday' },
                { value: 2, text: 'Tuesday' },
                { value: 3, text: 'Wednesday' },
                { value: 4, text: 'Thursday' },
                { value: 5, text: 'Friday' },
                { value: 6, text: 'Saturday' },
            ]
        },

        timeOfDayDisplay: {
            set(value) {
                console.log("time of day display:", value)
                const parts = (value ?? "").split(":");
                this.$set(this.model, 'time_of_day', Number(parts[0]) * 60 + Number(parts[1]))
            },
            get() {
                let x = this.model.time_of_day || 0;
                const hr = Math.floor(x / 60)
                const min = x - hr * 60;
                const y = `${String(hr).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
                console.log("y time of day:", y)
                return y;
            },
        },



    },

    watch: {
        scheduleItem: {
            immediate: true,
            handler: function (val) {
                if (val?.id) {
                    console.log("Model ITEM------:", val)
                    this.model = { ...val };
                    this.$set(this.model, "template_data", val?.email_template?.template);
                    this.$delete(this.model, "template");
                } else {
                    this.model = { ...default_model };
                }
            }, deep: true
        }
    },


    mounted() {
        if (this.item?.id) this.$store.dispatch("emailSchedules/fetchById", this.item.id)
        else this.$store.commit("emailSchedules/set_item", null)
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        is_one_off_linked(key) {
            const checkKeys = [
                "last_date",
                "day_of_week",
            ];
            const isIncluded = (key) => {
                const _is_included = checkKeys.includes(key);
                console.log({ key, _is_included });
                return _is_included;
            };
            return this.model.frequency == 0 && isIncluded(key);
        },
        getLabel(value) {
            return this.$translate(value);
        },

        getOptions(field) {
            console.log("field", field);
            switch (field) {
                case 'frequency':
                    return this.frequencies
                case 'day_of_week':
                    return this.weekDays
                case 'category':
                    return this.$store.state.emailSchedules?.options?.categories ?? []
                default: return []
            }

        },

        onSubmit() {

            const model = { ...(this.model || {}) };
            console.log('model', model)

            const path = model.id ? 'emailSchedules/update' : 'emailSchedules/create'
            const action = model.id ? this.$translate('updated') : this.$translate('created')
            const message = model.id ? this.$translate('update_alert') : this.$translate('create_alert')
            const callback = () => this.$emit('success', action, model.name, message)
            const payload = { data: model, callback };

            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$store.dispatch(path, payload)
                }
            })
        },

        triggerEmails() {
            this.$store.dispatch('emailSchedules/triggerEmails', this.model.id)
        },

        deleteEmailSchedule() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }

            // Generate and display confirmation prompt
            const title = this.$translate('delete_email_schedule_title')
            const message = `${this.$translate('delete_note')} ${model.name}?`;
            // const errorMsg = this.$translate('unable_alert')
            const alertMsg = this.$translate('delete_alert')
            const action = null;
            const cb = () => {
                this.$emit(
                    'success',
                    this.$translate('deleted'),
                    model.name,
                    alertMsg,
                    action
                );
            }
            const { id } = model;
            const payload = { id, cb }
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store.dispatch('emailSchedules/delete', payload)
                }
            })
        },
    },
}
</script>
<style></style>
